import axios from 'axios';
import { URL_BASE } from '../const/general';
import { fetchAuthSession } from 'aws-amplify/auth';

/**
 * 認証トークン付きでPOST送信
 */
export const postWithToken = async (url, data) => {
  let session;
  try {
    session = await fetchAuthSession();
  } catch {
    const error = new Error("セッション取得に失敗");
    error._is401 = true;
    throw error;
  }

  const idToken = session.tokens?.idToken?.toString();
  if (!idToken) {
    const error = new Error("idTokenが取得できません");
    error._is401 = true;
    throw error;
  }

  try {
    const res = await axios.post(URL_BASE + url, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`,
      },
    });
    return res.data;
  } catch (error) {
    if (error.response?.status === 401) {
      error._is401 = true;
    }
    throw error;
  }
};

/**
 * 認証トークン付きでDELETE送信
 */
export const deleteWithToken = async (url) => {
  let session;
  try {
    session = await fetchAuthSession();
  } catch {
    const error = new Error("セッション取得に失敗");
    error._is401 = true;
    throw error;
  }

  const idToken = session.tokens?.idToken?.toString();
  if (!idToken) {
    const error = new Error("idTokenが取得できません");
    error._is401 = true;
    throw error;
  }

  try {
    const res = await axios.delete(URL_BASE + url, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`,
      },
    });
    return res.data;
  } catch (error) {
    if (error.response?.status === 401) {
      error._is401 = true;
    }
    throw error;
  }
};